import React from 'react';

import { Box, Grid, GridItem } from '@chakra-ui/react';
import { GenericNumericInput } from 'components/RabbitOKRSidePanel/Components/GenericNumericInputWithValidation';
import OKRMeasure from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Measure/OKRMeasure';
import { OKRMetric } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Measure/OKRMetric';

import { OKR_PROGRESS_TYPES } from 'constants/ProjectConstants';
import { isMobileView } from 'constants/isMobileView';

import { Tooltip } from 'uiToolkitV1/Tooltip';
import { TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  startingProgressValue: number;
  target: number;
  measureType: string;
  measure: string;
  onChange?: (updates: any) => void;
  onValueChange?: (updates: any) => void;
  isReadOnly: boolean;
  parentProgressType: string;
}

const ManualTracking = ({
  startingProgressValue,
  target,
  measureType,
  measure,
  onChange = () => {},
  onValueChange = () => {},
  isReadOnly,
  parentProgressType,
}: Props) => {
  const isParentProgressTypeDerivedSum = parentProgressType === OKR_PROGRESS_TYPES.DERIVED_SUM;
  const showInfoTooltip = !isReadOnly && isParentProgressTypeDerivedSum;

  return (
    // @ts-expect-error : union too complex
    <Grid
      gridTemplateColumns={isMobileView() ? '40% 10% 40%' : '15% 4% 19% 12% 42%'}
      rowGap={isMobileView() ? '16px' : '0'}
      justifyContent="space-between"
      mb="16px"
    >
      <GridItem
        sx={{
          '.generic-numeric-input-label': {
            padding: 0,
          },
          input: {
            padding: '12px 4px',
          },
        }}
      >
        {/* 
          // In chakra - 2 shouldWrapChildren prop adds a span around the children
          // which breaks the layout.
          // Instead try to wrap children in forwardRef or 
          // wrap the component in a Box/Flex
          // so Tooltip can attach a ref without breaking the layout.
        */}
        <Tooltip label="Start Value">
          <Box>
            <GenericNumericInput
              value={startingProgressValue}
              // @ts-ignore
              onChange={(startingProgressValue) => onChange({ startingProgressValue })}
              // @ts-ignore
              onValueChange={(startingProgressValue) => {
                onValueChange({ startingProgressValue });
              }}
              isReadOnly={isReadOnly}
              errorMessage="Start value is a mandatory field"
              isMandatory={false}
            />
          </Box>
        </Tooltip>
      </GridItem>
      <GridItem display="flex" alignItems="center">
        <TextLabel color="text.g2">to</TextLabel>
      </GridItem>
      <GridItem
        sx={{
          '.generic-numeric-input-label': {
            padding: 0,
          },
          input: {
            padding: '12px 4px',
          },
        }}
      >
        <Tooltip label="Target Value">
          <Box>
            <GenericNumericInput
              value={target}
              // @ts-ignore
              onChange={(target) => onChange({ target })}
              // @ts-ignore
              onValueChange={(target) => {
                onValueChange({ target });
              }}
              isReadOnly={isReadOnly}
              errorMessage="Target value is a mandatory field"
              isMandatory={false}
            />
          </Box>
        </Tooltip>
      </GridItem>
      <GridItem
        sx={{
          '.measure-select-label': {
            padding: 0,
          },
        }}
      >
        <Tooltip label="Measured in">
          <Box>
            <OKRMeasure
              measure={measure}
              onChange={(measure) => {
                onChange({ measure });
                onValueChange({ measure });
              }}
              isReadOnly={isReadOnly || isParentProgressTypeDerivedSum}
              showInfoTooltip={showInfoTooltip}
              showLabel={false}
              hideSymbolText
            />
          </Box>
        </Tooltip>
      </GridItem>
      <GridItem
        gridColumn={isMobileView() ? '2/4' : 'auto'}
        sx={{
          '.metric-select-label': {
            padding: 0,
          },
        }}
      >
        <Tooltip label="Metric">
          <Box>
            <OKRMetric
              measureType={measureType}
              // @ts-ignore
              onChange={(measureType) => onChange({ measureType })}
              onValueChange={(measureType) => onValueChange({ measureType })}
              isReadOnly={isReadOnly || isParentProgressTypeDerivedSum}
              showInfoTooltip={showInfoTooltip}
              showTextTooltip
              showLabel={false}
            />
          </Box>
        </Tooltip>
      </GridItem>
    </Grid>
  );
};

export { ManualTracking };
